import watchOneRetina from 'marketing-website/media/images/pages/features/wireframing/watchOne@2x.png';
import watchTwoRetina from 'marketing-website/media/images/pages/features/wireframing/watchTwo@2x.png';
import wireframeRetina from 'marketing-website/media/images/pages/features/wireframing/wireframe@2x.png';
import mapsRetina from 'marketing-website/media/images/pages/features/wireframing/maps@2x.png';
import shareRetina from 'marketing-website/media/images/pages/features/wireframing/share@2x.png';
import cameraRetina from 'marketing-website/media/images/pages/features/wireframing/camera@2x.png';
import canvasRetina from 'marketing-website/media/images/pages/features/wireframing/canvas@2x.jpg';
import wireframeFallbackRetina from 'marketing-website/media/images/pages/features/wireframing/wireframeFallback@2x.png';
import screensFallbackRetina from 'marketing-website/media/images/pages/features/wireframing/screens.png';

const assets = {
  watchOne: {
    alt: '',
    src: watchOneRetina,
  },
  watchTwo: {
    alt: '',
    src: watchTwoRetina,
  },
  wireframe: {
    alt: '',
    src: wireframeRetina,
  },
  experimentBlock: [
    {
      alt: 'Android Maps Wireframe',
      id: 0,
      src: mapsRetina,
    },
    {
      alt: 'Android Maps Wireframe',
      id: 1,
      src: shareRetina,
    },
    {
      alt: 'Android Maps Wireframe',
      id: 2,
      src: cameraRetina,
    },
  ],
  canvas: {
    alt: '',
    src: canvasRetina,
  },
  wireframeFallbackRetina: {
    alt: '',
    src: wireframeFallbackRetina,
    maxWidth: 521,
  },
  screensFallbackRetina: {
    alt: '',
    src: screensFallbackRetina,
    maxWidth: 1224,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/features/wireframing/assets.js